import { useFormik } from "formik";
import * as Yup from "yup";
import AlertErrorForm from "../../component/AlertErrorForm";
import { Modal } from "react-bootstrap";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import { checkRole } from "../../model";

export default function ModalNote({
  showFullPhones,
  setShowFullPhones,
  item,
  user,
  pipelines,
  onClose,
}) {
  const allowTakeCare = checkRole(user, "khach-hang-cua-toi", "takecare");
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      user_id: user.data.id,
      customer_id: item?.id,
      action: "note",
      mainnote: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      mainnote: Yup.string()
        .trim()
        .nullable()
        .required("Nhập nội dung")
        .max(150, "Độ dài không quá 150 ký tự"),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setLoading(true);
      Axios.post(URL_LIST_ALL + "sale_customer", values, user.config)
        .then(() => {
          setLoading(false);
          setSubmitting(false);
          resetForm();
          onClose(); // đóng modal sau khi lưu
        })
        .catch((err) => console.log(err));
    },
  });

  const getPhoneDisplay = (item) => {
    if (!item) return null;
    const phone = item.contact || "";
    const digits = phone.replace(/\D/g, "");
    if (showFullPhones === item.id) return digits;
    if (digits.length < 7) return digits;
    return `${digits.slice(0, 3)}****${digits.slice(-3)}`;
  };

  const mau_cautraloi = [
    "Không nghe máy",
    "Tắt máy luôn",
    "Kết bạn gửi Zalo",
    "Thuê bao",
    "Báo gọi lại sau",
  ];

  const updateStatus = (status, title) => {
    onClose();
    confirmAlert({
      title: "Thông báo",
      message: "Bạn có chắc chắn muốn chuyển sang " + title,
      buttons: [
        {
          label: "Có",
          onClick: () => {
            Axios.post(
              URL_LIST_ALL + "sale_customer",
              {
                user_id: user.data.id,
                customer_id: item.id,
                action: "note",
                mainnote: "Chuyển sang <strong>" + title + "</strong>",
                status: 1,
              },
              user.config
            ).catch((err) => console.log(err));
            Axios.put(
              URL_LIST_ALL + "leads/" + item.id,
              { position: status },
              user.config
            ).catch((err) => console.log(err));
          },
        },
        { label: "Không" },
      ],
    });
  };

  const khachnet = () => {
    if (!item.net || item.net == 0) {
      confirmAlert({
        title: "Thông báo",
        message: "Bạn muốn đánh dấu khách nét ?",
        buttons: [
          {
            label: "Có",
            onClick: () => {
              Axios.put(
                URL_LIST_ALL + "leads/" + item.id,
                { net: item.net && item.net == 1 ? 0 : 1 },
                user.config
              )
                .then(() => {
                  let datasave = {
                    user_id: user.data.id,
                    customer_id: item.customer_id,
                    action: "note",
                    mainnote: "Đánh dấu khách nét",
                  };
                  Axios.post(
                    URL_LIST_ALL + "sale_customer",
                    datasave,
                    user.config
                  ).catch((err) => console.log(err));
                })
                .catch((err) => console.log(err));
            },
          },
          { label: "Không" },
        ],
      });
    }
  };

  const startTakeCare = (item) => {
    if (item.position != 3 && allowTakeCare) {
      let datasave = {
        user_id: user.data.id,
        customer_id: item.customer_id,
        action: "note",
        mainnote: "Bắt đầu chăm sóc khách",
      };
      Axios.post(URL_LIST_ALL + "sale_customer", datasave, user.config).catch(
        (err) => console.log(err)
      );
    }
  };

  return (
    <Modal
      className="modal-sale-action"
      show={true}
      onHide={onClose}
      animation={true}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Ghi chú khách hàng: {item && item.fullname} |{" "}
          <button
            type="button"
            className="btn btn-sm btn-info"
            disabled={item.status == 1 ? false : true}
            onClick={() => {
              if (showFullPhones !== item.id) startTakeCare(item);
              setShowFullPhones(showFullPhones === item.id ? null : item.id);
            }}
          >
            <span>{getPhoneDisplay(item)}</span>
          </button>
          {item.status == 1 &&
            <button
              type="button"
              className="btn btn-sm btn-success ml-2"
              onClick={() => {
                startTakeCare(item);
                window.location.href = `tel:${item.contact}`;
              }}
            >
              <i className="fas fa-phone-volume mr-1"></i> Gọi
            </button>
          }

          <button
            type="button"
            className={
              "btn btn-sm ml-2 " +
              (item.net && item.net == 1 ? "btn-warning" : "btn-outline-warning")
            }
            onClick={() => khachnet()}
          >
            <span className="fas fa-star"></span> Nét
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-12">
              {item.status == 1 && mau_cautraloi.map((txt) => (
                <button
                  type="button"
                  className="btn btn-sm btn-secondary mr-2 mb-2"
                  key={txt}
                  onClick={() => formik.setFieldValue("mainnote", txt)}
                >
                  {txt}
                </button>
              ))}
            </div>
            <div className="col-12">
              {pipelines && item.status == 1 &&
                pipelines.map((pipeline) => {
                  if (
                    item.position != pipeline.position &&
                    checkRole(user, pipeline.alias, "move")
                  ) {
                    return (
                      <button
                        key={pipeline.id}
                        type="button"
                        className={"btn btn-sm mr-2 mb-2 " + pipeline.alias}
                        onClick={() =>
                          updateStatus(pipeline.position, pipeline.title)
                        }
                        style={{
                          backgroundColor: pipeline.header_color
                            ? pipeline.header_color
                            : "transparent",
                          color: pipeline.text_color
                            ? pipeline.text_color
                            : "inherit",
                          border: "1px solid",
                        }}
                      >
                        {item.position <= pipeline.position
                          ? "Chuyển sang"
                          : "Chuyển về"}{" "}
                        "{pipeline.title}"
                      </button>
                    );
                  } else {
                    return null;
                  }
                })}
            </div>

            <div className="col-12 form-group mt-2">
              <label>
                Nội dung ghi chú <span className="text-danger">*</span>
              </label>
              <textarea
                type="text"
                placeholder="Nhập nội dung"
                className="form-control"
                {...formik.getFieldProps("mainnote")}
                autoComplete="off"
              ></textarea>
              <AlertErrorForm formik={formik} name="mainnote" />
            </div>

            <div className="col-12 form-group mg-t-8">
              <button
                type="submit"
                disabled={formik.isSubmitting}
                className="btn btn-success"
              >
                {loading ? <div className="loader"></div> : <>Lưu lại</>}
              </button>
              <button
                type="reset"
                onClick={formik.resetForm}
                className="btn btn-warning ml-2"
              >
                Nhập lại
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
